import styled from "styled-components";
import { FiFileText } from "react-icons/fi";
import media from "../../styles/media";
import { Card } from "../ui/Card";

const ReportLink = styled.a`
  display: flex;
  align-items: center;
  gap: 14px;
  height: 100%;
  color: inherit;

  &:hover {
    text-decoration: none;
  }
`;

const Icon = styled(FiFileText)`
  flex-shrink: 0;
  font-size: 30px;
  color: ${({ theme }) => theme.colors.primary};

  ${media.md} {
    font-size: 26px;
  }
`;

const Name = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};

  ${media.md} {
    font-size: ${({ theme }) => theme.fontSizes.md};
  }
`;

/**
 * Карточка отчёта: используется и на странице «Отчеты», и в блоке на главной,
 * чтобы вид не разъезжался при правках в одном из мест.
 *
 * @param {{ report: { name: string, href: string }, headingLevel?: string }} props
 *        `headingLevel` — уровень заголовка для корректной структуры страницы.
 */
export function ReportCard({ report, headingLevel = "h2" }) {
  return (
    <Card>
      <ReportLink href={report.href} target="_blank" rel="noopener noreferrer">
        <Icon aria-hidden="true" />
        <Name as={headingLevel}>{report.name}</Name>
      </ReportLink>
    </Card>
  );
}

export default ReportCard;
